import { useCallback, useContext, useMemo } from 'react'
import { useConfig } from '../providers/config'
import { useStore } from '../providers/store'
import { groupBy } from 'lodash'
import CookiesContext from 'react-cookie/es6/CookiesContext'
import { getNextTenDaysDate, reduceCookiesByGroup, reduceCookiesByStore, removeTrailingSlashes } from '../utils'
import {
	COOKIE_NAME_CURRENCY,
	COOKIE_NAME_SALES_AGENT_GROUP,
	COOKIE_NAME_USER_GROUP,
	SALES_AGENT_GROUP_NOT_LOGGED_IN,
	USER_GROUP_NOT_LOGGED_IN,
} from '../constants'

const BH_VARY = process.env.NEXT_PUBLIC_BH_VARY

export const useVary = () => {
	const { availableStores } = useConfig()
	const { groupId, hostname: currentHostname, code: storeCode } = useStore()

	const storesOfCurrentGroup = useMemo(
		() => groupBy(availableStores, 'groupId')[groupId] || [],
		[availableStores, groupId]
	)

	const storesOfCurrentGroupAndCurrentHostname = storesOfCurrentGroup?.filter(
		({ hostname }) => hostname === currentHostname
	)

	const cookies = useContext(CookiesContext)

	const update = useCallback(() => {
		const newCookies = cookies.getAll({
			doNotUpdate: true,
		})

		const cookiesByGroup = reduceCookiesByGroup(newCookies, groupId)
		const cookiesByStore = reduceCookiesByStore(newCookies, storeCode)
		const userGroup = cookiesByGroup[COOKIE_NAME_USER_GROUP] ?? USER_GROUP_NOT_LOGGED_IN
		const salesAgentGroup = cookiesByGroup[COOKIE_NAME_SALES_AGENT_GROUP] ?? SALES_AGENT_GROUP_NOT_LOGGED_IN
		const currency = cookiesByStore[COOKIE_NAME_CURRENCY]

		for (const storeOfCurrentGroupAndCurrentUrl of storesOfCurrentGroupAndCurrentHostname) {
			const { path, hostname: domain } = storeOfCurrentGroupAndCurrentUrl
			cookies.set(BH_VARY, `${currency}_${userGroup}_${salesAgentGroup}`, {
				path: `${removeTrailingSlashes(path)}/`,
				domain,
				expires: getNextTenDaysDate(), // keep in sync with user group cookies expiration
				secure: true,
			})
		}
	}, [cookies, groupId, storeCode, storesOfCurrentGroupAndCurrentHostname])

	return { update }
}
